"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderLogo = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./ProviderLogo.css"));
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _clsx = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProviderLogo = props => {
  const {
    logo,
    type
  } = props;
  const [error, setError] = React.useState(false);
  const handleError = React.useCallback(() => {
    setError(true);
  }, []);
  const showLogo = logo && !error;
  const showPlaceholder = !logo || error;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(type === 'bank' && style['bank-logo'])
  }, showLogo && /*#__PURE__*/React.createElement("img", {
    src: logo,
    className: style['provider-logo'],
    onError: handleError
  }), showPlaceholder && /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['provider-logo'], style['placeholder-logo'])
  }, type === 'builder' ? /*#__PURE__*/React.createElement(_icons.IconPlaceholderBuilder16, {
    color: "icon-secondary-disabled"
  }) : /*#__PURE__*/React.createElement(_uiKit.IconBank16, {
    color: "icon-secondary-disabled"
  })));
};
exports.ProviderLogo = ProviderLogo;